export const getLocationFormFields = (location: any) => {
  const fieldsToUpdate: { [key: string]: string } = {
    countryIso2Code: '',
    cityName: '',
    address: '',
    postalCode: '',
    countryName: '',
  };

  let street_number = '';
  let street_name = '';

  location.address_components.forEach((component: any) => {
    switch (component.types[0]) {
      case 'street_number':
        street_number = component.long_name;
        break;
      case 'route':
        street_name = component.long_name;
        break;
      case 'locality':
        fieldsToUpdate.cityName = component.long_name;
        break;
      case 'country':
        fieldsToUpdate.countryIso2Code = component.short_name;
        fieldsToUpdate.countryName = component.long_name;
        break;
      case 'postal_code':
        fieldsToUpdate.postalCode = component.long_name;
        break;
    }
  });

  const streetNameAndNumber =
    street_name && street_number
      ? `${street_name} ${street_number}`
      : street_name
      ? street_name
      : street_number
      ? street_number
      : '';

  fieldsToUpdate.address = streetNameAndNumber;

  return fieldsToUpdate;
};
